import { render, staticRenderFns } from "./appointmentOrgStatistics.vue?vue&type=template&id=72284866&scoped=true"
import script from "./appointmentOrgStatistics.vue?vue&type=script&lang=js"
export * from "./appointmentOrgStatistics.vue?vue&type=script&lang=js"
import style0 from "./appointmentOrgStatistics.vue?vue&type=style&index=0&id=72284866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72284866",
  null
  
)

export default component.exports